module.exports = __webpack_public_path__ + "static/media/YDQserie.e51a30e8.jpg";